<template>
	<v-dialog v-model="dialog" max-width="500">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2" v-bind="attrs" v-on="on">
				<slot name="open-btn-content">
					<v-icon class="mr-1">mdi-check</v-icon>
					{{ title }}
				</slot>
			</v-btn>
		</template>

		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> {{ title }}</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<p>承認しますか？</p>
				<v-row no-gutters justify="space-around">
					<v-btn class="mt-4" color="secondary" @click="approve()">
						<v-icon class="mr-1">mdi-check</v-icon>
						承認
					</v-btn>
					<v-btn class="mt-4" dark color="red" @click="showRejectForm = true">
						<v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
						差し戻し
					</v-btn>
				</v-row>
				<div class="mt-4" v-if="showRejectForm">
					<v-form ref="form" v-model="valid">
						<v-textarea
							v-model="reason"
							label="差し戻し理由(必須)"
							:rules="[rules.required]"
							persistent-hint
							:hint="'差し戻し理由はメッセージで送信されます。'"
							outlined
							dense
						/>
					</v-form>
					<v-row no-gutters justify="space-around">
						<v-btn class="mt-4" color="red" :disabled="!valid" @click="submitForm()">
							<v-icon class="mr-1">mdi-send</v-icon>
							差し戻し
						</v-btn>
						<v-btn class="mt-4" @click="closeDialog()">キャンセル</v-btn>
					</v-row>
				</div>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import rules from "../../../helper/rules"

export default {
	props: {
		title: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			showRejectForm: false,
			reason: null,
			dialog: false,
			rules,
		}
	},
	methods: {
		approve() {
			this.$emit("approve")
			this.closeDialog()
		},
		submitForm() {
			this.$emit("reject", this.reason)
			this.closeDialog()
		},
		closeDialog() {
			this.$refs.form.reset()
			this.showRejectForm = false
			this.reason = null
			this.dialog = false
		},
	},
	computed: {
		dialog: {
			get() {
				return this.dialog
			},
			set(val) {
				this.$emit("update:dialog", val)
			},
		},
	},
	watch: {},
}
</script>

<style lang="scss" scoped>
span {
	white-space: pre-wrap;
}
</style>
